import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Youtube, Instagram } from "lucide-react";
import YoutubeSection from "@/pages/client-tabs/YoutubeSection";
import InstagramSection from "@/pages/client-tabs/InstagramSection";

/**
 * "Otros" container — hosts additional platform widgets (YouTube, Instagram…).
 * Used inside both Comunicación and SEO tabs. (Meta Ads lives in CRO → Performance.)
 */
export default function OtrosSection({ clientId, defaultPlatform = "youtube" }) {
  return (
    <div className="space-y-4" data-testid="otros-section">
      <Tabs defaultValue={defaultPlatform} className="w-full">
        <TabsList className="h-auto p-1 bg-slate-100 border border-slate-200 rounded-md inline-flex gap-1 flex-wrap">
          <TabsTrigger
            value="youtube"
            data-testid="otros-tab-youtube"
            className="data-[state=active]:bg-white data-[state=active]:shadow-sm data-[state=active]:text-slate-900 text-slate-600 px-3 py-1.5 rounded-sm text-xs font-medium gap-1.5"
          >
            <Youtube className="h-3.5 w-3.5 text-red-600" /> YouTube
          </TabsTrigger>
          <TabsTrigger
            value="instagram"
            data-testid="otros-tab-instagram"
            className="data-[state=active]:bg-white data-[state=active]:shadow-sm data-[state=active]:text-slate-900 text-slate-600 px-3 py-1.5 rounded-sm text-xs font-medium gap-1.5"
          >
            <Instagram className="h-3.5 w-3.5 text-pink-600" /> Instagram
          </TabsTrigger>
        </TabsList>

        <TabsContent value="youtube" className="mt-4">
          <YoutubeSection clientId={clientId} />
        </TabsContent>

        <TabsContent value="instagram" className="mt-4">
          <InstagramSection clientId={clientId} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
